// SPM — FAQ Accordion
// Smooth expand/collapse for <details class="spm-faq-item"> using the
// Web Animations API, same approach as spm-bundled-products.js.

document.addEventListener('DOMContentLoaded', function () {
  // If the page was loaded with a #anchor pointing at a question, open it and scroll to it.
  if (window.location.hash) {
    var targetId = window.location.hash.slice(1);
    var target = document.getElementById(targetId);
    if (target && target.classList.contains('spm-faq-item')) {
      target.open = true;
      // Wait a tick for layout, then scroll (scroll-margin-top handles header offset).
      window.requestAnimationFrame(function () {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }

  var items = document.querySelectorAll('.spm-faq-item');

  items.forEach(function (details) {
    var summary = details.querySelector('summary');
    var answer = details.querySelector('.spm-faq-item__answer');
    var animation = null;
    var isClosing = false;
    var isExpanding = false;

    summary.addEventListener('click', function (e) {
      e.preventDefault();
      details.style.overflow = 'hidden';

      if (isClosing || !details.open) {
        openDetails();
      } else if (isExpanding || details.open) {
        shrink();
      }
    });

    function shrink() {
      isClosing = true;
      var startHeight = details.offsetHeight + 'px';
      var endHeight = summary.offsetHeight + 'px';

      if (animation) {
        animation.cancel();
      }

      animation = details.animate(
        { height: [startHeight, endHeight] },
        { duration: 200, easing: 'ease-out' }
      );

      animation.onfinish = function () {
        onAnimationFinish(false);
      };
      animation.oncancel = function () {
        isClosing = false;
      };
    }

    function openDetails() {
      details.style.height = details.offsetHeight + 'px';
      details.open = true;
      window.requestAnimationFrame(function () {
        expand();
      });
    }

    function expand() {
      isExpanding = true;
      var startHeight = details.offsetHeight + 'px';
      var endHeight = summary.offsetHeight + answer.offsetHeight + 'px';

      if (animation) {
        animation.cancel();
      }

      animation = details.animate(
        { height: [startHeight, endHeight] },
        { duration: 200, easing: 'ease-out' }
      );

      animation.onfinish = function () {
        onAnimationFinish(true);
      };
      animation.oncancel = function () {
        isExpanding = false;
      };
    }

    function onAnimationFinish(open) {
      details.open = open;
      animation = null;
      isClosing = false;
      isExpanding = false;
      details.style.height = details.style.overflow = '';
    }

    // Keep open items sized correctly if window resizes (e.g. text reflow on mobile rotate)
    var resizeObserver = new MutationObserver(function () {
      if (details.open && !isExpanding && !isClosing) {
        details.style.height = 'auto';
      }
    });
    resizeObserver.observe(details, { attributes: true, attributeFilter: ['open'] });
  });
});